import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { Skeleton } from "@/components/ui/skeleton";

export default function ImageGrid({ results, loading }) {
  if (loading && (!results || results.length === 0)) {
    return (
      <div className="px-3 sm:px-6 py-3 sm:py-4 overflow-hidden">
        <div className="image-masonry">
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} className="w-full bg-white/5 rounded-lg" style={{ height: `${120 + Math.random() * 100}px` }} />
          ))}
        </div>
      </div>
    );
  }

  if (!results || results.length === 0) return null;

  return (
    <div data-testid={HOME.imageGrid} className="px-3 sm:px-6 py-3 sm:py-4 overflow-hidden">
      <div className="image-masonry">
        {results.map((img, idx) => (
          <ImageCard key={`${img.position}-${idx}`} image={img} index={idx} />
        ))}
      </div>
    </div>
  );
}

function ImageCard({ image, index }) {
  const [imgError, setImgError] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);

  if (imgError || !image.thumbnail) return null;

  return (
    <div
      data-testid={HOME.imageCard}
      className="image-card-hover group relative rounded-lg sm:rounded-xl overflow-hidden bg-[#121214] border border-white/5 cursor-pointer"
    >
      <a href={image.source_url} target="_blank" rel="noopener noreferrer" className="block">
        <div className="relative overflow-hidden">
          {!imgLoaded && <Skeleton className="absolute inset-0 bg-white/5" />}
          <img
            src={image.thumbnail}
            alt={image.title || "Resultado"}
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgError(true)}
            className={`w-full block transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <div className="absolute bottom-2 right-2">
              <ExternalLink className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white/80" />
            </div>
          </div>
        </div>

        <div className="p-1.5 sm:p-2.5">
          {image.title && (
            <p className="text-[10px] sm:text-[11px] text-white/70 leading-snug line-clamp-2">
              {image.title}
            </p>
          )}
          {image.website && (
            <div className="flex items-center gap-1 mt-1">
              {image.favicon && (
                <img src={image.favicon} alt="" className="w-3 h-3 rounded-sm" onError={(e) => { e.target.style.display = 'none'; }} />
              )}
              <span className="text-[9px] sm:text-[10px] font-mono text-white/30 truncate">{image.website}</span>
            </div>
          )}
        </div>
      </a>
    </div>
  );
}
